import { render, staticRenderFns } from "./HomeProduct.vue?vue&type=template&id=58849e24&scoped=true"
import script from "./HomeProduct.vue?vue&type=script&lang=js"
export * from "./HomeProduct.vue?vue&type=script&lang=js"
import style0 from "./HomeProduct.vue?vue&type=style&index=0&id=58849e24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_css-loader@6.11.0_webpack@5.102.1__lodash@4_84c89ef1ca8e21ad744d928d5a51d316/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58849e24",
  null
  
)

export default component.exports